import React, { useEffect, useRef } from 'react';

const DisclaimerText = (props) => {
  const { typeContainer, disclaimer, disclaimerInfo, disclaimerOption, isTypeInfo, customClass, disclaimerColor } = props;

  const disclaimerOptionFlag = disclaimerOption || 'bottom-left';

  const containerRef = useRef(null);
  useEffect(() => {
    const container = containerRef.current;
    const textDisclaimers = container.querySelectorAll('.text-declaimer-box');
    textDisclaimers.forEach((el, _i) => {
      if (el.closest('.mod-search-results')) {
        el.classList.add(`box-declaimer-clone`, `box-declaimer-clone-${_i}`, `z-100`, `top-20`);
        el.classList.remove('z-40');
        const clone = el.cloneNode(true);
        const btnInfo = el.parentElement.querySelector('.btn-info');
        btnInfo.classList.add(`btn-info-clone-${_i}`);
        btnInfo.setAttribute('data-declaimer', `box-declaimer-clone-${_i}`);
        document.body.appendChild(clone);
        el.remove();
      }
    });
  }, []);

  const buttonDisclaimerInfo = typeContainer ? (
    <div className={`container declaimer-container z-40 absolute left-0 right-0 
      ${disclaimerOption} ${disclaimerOptionFlag.split('-')[0]}-0 text-${disclaimerOptionFlag.split('-')[1]}`}>
      <button type="button" className={`btn-info declaimer-text hover:underline underline-offset-4 font-bold ${disclaimerColor ? 'text-black' : 'text-white'} text-xs text-left max-w-500 leading-tight inline-block mt-8 mb-10 mouse`}>
        {disclaimerInfo}
      </button>
    </div>
  ) : (
    <button
      type="button"
      className={`btn-info declaimer-text hover:underline underline-offset-4 font-bold ${disclaimerColor ? 'text-black' : 'text-white'} text-xs text-left max-w-500 leading-tight inline-block z-40 absolute m-8 ${customClass}
      ${disclaimerOptionFlag} ${disclaimerOptionFlag.split('-')[1]}-0 ${disclaimerOptionFlag.split('-')[0]}-0`}
    >
      {disclaimerInfo}
    </button>
  );

  const ButtonDisclaimerText = typeContainer ? (
    <div className={`container declaimer-container z-10 absolute left-0 right-0
      ${disclaimerOptionFlag} ${disclaimerOptionFlag.split('-')[0]}-0 text-${disclaimerOptionFlag.split('-')[1]}`}>
      <div className={`declaimer-text text-white text-xs text-left max-w-500 leading-tight bg-black-60 py-2 px-5 rounded-2xl m-8 ${customClass}`}>
        {disclaimer}
      </div>
    </div>
  ) : (
    <div className={`declaimer-text text-white text-xs text-left max-w-500 leading-tight bg-black-60 py-2 px-5 rounded-2xl inline-block z-10 absolute m-8 ${customClass}
    ${disclaimerOptionFlag} ${disclaimerOptionFlag.split('-')[1]}-0 ${disclaimerOptionFlag.split('-')[0]}-0`}>
      {disclaimer}
    </div>
  );

  return <div ref={containerRef}>
    {disclaimer && (isTypeInfo ? (
      <>
        {buttonDisclaimerInfo}
        <div className="text-declaimer-box flex absolute inset-0 items-center justify-center bg-black-90 text-white text-base z-40 opacity-0 pointer-events-none px-10">
          {disclaimer}
          <button type="button" className="close-declaimer absolute right-5 top-3 text-h3">
            <span className="icomoon icon-close" aria-hidden="true" />
            <span className="sr-only">close declaimer</span>
          </button>
        </div>
      </>
    ) : ButtonDisclaimerText)}
  </div>;
};

export default DisclaimerText;